import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=ddd6d304&scoped=true&"
var script = {}
import style0 from "./Landing.vue?vue&type=style&index=0&id=ddd6d304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd6d304",
  null
  
)

export default component.exports